$(document).off('click', '.btn-delete-item1')
$(document).on('click', '.btn-delete-item1', function(){
  const $tr = $(this).closest('tr')
  const $tbody = $tr.closest('tbody')

  if ($tr.find("[nested_item_id]").length) {
    $tr.find("[nested_item_status]").val("deleted")
    $tr.attr('hidden', 'hidden')
    return false;
  }

  let last_tr = false

  if ($tbody.find("tr:eq(-1)").attr('n') == $tr.attr('n')) {
    last_tr = true
  }

  if (last_tr){
    $tr.find('[selector]').val('')
    $tr.find('[selector]').trigger('change')
    $tr.find('[autofill]').html('')
    return true
  }

  if ($tr.attr('destroyed') != undefined) {
    $tr.remove()
    return true
  }
})

$(document).off("change", "select[trig_ai]")
$(document).on("change", "select[trig_ai]", function(){
  if ($(this).val() == "") {
    return true
  }

  const $tr = $(this).closest('tr')
  const $tbody = $tr.closest('tbody')

  if ($tbody.find("tr:eq(-1)").attr('n') != $tr.attr('n')) {
    return true
  }

  const $new_tr = $tbody.closest('table').find('tfoot').html()
  $tbody.append($new_tr)

  const $appended_tr = $tbody.find("tr:eq(-1)")
  $appended_tr.attr('destroyed', '')
  $appended_tr.attr('n', (parseInt($tr.attr('n')) + 1))
  $appended_tr.find('select').attr('class', $tr.find('select').attr('class'))

  initializeSelect2EmployeeItem()
})